export const carTableRows = [
  {
    licensePlate: `F4M1LY`,
    make: `Chrysler`,
    model: `Pacifica`,
    year: `2020`,
    owner: `Alex`,
  },
  {
    licensePlate: `ABC1234`,
    make: `Nissan`,
    model: `Rogue`,
    year: `2011`,
    owner: `You`,
  },
  {
    licensePlate: `AWE50M3`,
    make: `Lamborghini`,
    model: `Aventador`,
    year: `2011`,
    owner: `Mixpanel`,
  },
];
